import React, { Component } from 'react';
import brandLogo from '../images/brand-logo-inverse-dark.png';
import { translate } from 'react-i18next';
import Input from '../components/Input';
import Spinner from '../components/Spinner';

class Signup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      passwordVerification: {
        uppercase: false,
        lowercase: false,
        digits: false,
        specialChar: false,
        minLength: false
      },
      error: false
    }
  }

  componentDidMount() {
    window.fbLoaded.promise.then(() => {
      window.FB.XFBML.parse();
      // var spinner = document.getElementById("facebookSpinner");
      // spinner.removeAttribute("class");
      // spinner.removeChild(spinner.childNodes[0]);
    });

    // let thiss = this;
    window.googleLoaded.promise.then(() => {
      this.props.loadGoogle("SIGNUP");
    });

    // Actualiza el estado de los campos validos
    this.handlePassword({ target: { value: this.props.password } });
  }

  handlePassword = (e) => {
    const pass = e.target.value;
    this.props.handlePasswordChange(e);

    const uppercaseRegExp   = /(?=.*?[A-Z])/;
    const lowercaseRegExp   = /(?=.*?[a-z])/;
    const digitsRegExp      = /(?=.*?[0-9])/;
    const specialCharRegExp = /(?=.*?[#?!@$%^&*-.'"])/;
    const minLengthRegExp   = /.{8,}/;

    const uppercasePassword = uppercaseRegExp.test(pass);
    const lowercasePassword = lowercaseRegExp.test(pass);
    const digitsPassword = digitsRegExp.test(pass);
    const specialCharPassword = specialCharRegExp.test(pass);
    const minLengthPassword = minLengthRegExp.test(pass);

    this.setState({
      passwordVerification: {
        uppercase: uppercasePassword,
        lowercase: lowercasePassword,
        digits: digitsPassword,
        specialChar: specialCharPassword,
        minLength: minLengthPassword
      }
    })
  }

  handleValidate = ({ name, isValid }) => {
    this.setState({
      fieldsValid: {
        ...this.state.fieldsValid,
        [name]: isValid
      }
    })

    if (name === "passwordConfirm") {
      if (this.props.password !== this.props.passwordConfirm) {
        this.setState({
          error: 'Las contraseñas no coinciden',
          fieldsValid: {
            ...this.state.fieldsValid,
            passwordConfirm: false
          }
        });
      } else {
        this.setState({
          error: false
        });
      }
    }
  }

  handleClearError = () => {
    this.setState({
      error: false
    });
  }

  handleSignupSubmit = (e) => {
    e.preventDefault();
    const isValid = Object.values(this.state.fieldsValid).every((field) => field);
    if (isValid) {
      this.props.handleSignupSubmit(e);
    } else {
      this.setState({
        error: 'Todos los campos son requeridos'
      });
    }
  }

  render() {
    const { t } = this.props;
    const check = <i className="fa-solid fa-check success-text"></i>;
    const incorrect = <i className="fa-solid fa-xmark error-text"></i>;
    const pattern = "(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-.'\"]).{8,}";

    const isPasswordValid = Object.values(this.state.passwordVerification).every(v => v === true);
    const doPasswordsMatch = this.props.password && this.props.password === this.props.passwordConfirm;
    const isFormValid = isPasswordValid && doPasswordsMatch && !this.state.error;

    return (
      <div className="panel">
        {this.props.isLoading && (
          <div className="spinner-centered">
            <Spinner />
          </div>
        )}
        <div className="panel-content">
          <div className="panel-heading-signup text-center">
            <img height="50px" alt="IOS OFFICES" src={brandLogo} />
          </div>

          <div className="panel-body-singup">
            <h4>{t('onboarding.signup.heading')}</h4>
            <form method="post" onSubmit={this.handleSignupSubmit}>
              <fieldset>
                <div className="form-group">
                  <Input
                    className="form-control"
                    onChange={this.props.handleEmailChange}
                    placeholder={t('onboarding.signup.holder_email')}
                    required
                    type="email"
                    autoFocus
                    value={this.props.email} />
                </div>
                <div className="form-group">
                  <Input
                    className="form-control"
                    onChange={this.handlePassword}
                    placeholder={t('onboarding.signup.holder_password')}
                    required
                    type="password"
                    pattern={pattern}
                    onValidate={this.handleValidate}
                    value={this.props.password} />
                </div>
                <div style={{ textAlign: "left"}} >
                  <h5>{t('onboarding.signup.pass_requirements_text')}</h5>
                  <ul>
                    <li>
                      {t('onboarding.signup.pass_requirements.length')} {" "}
                      {this.state.passwordVerification.minLength ? check : incorrect}
                    </li>
                    <li>
                      {t('onboarding.signup.pass_requirements.uppercase')} {" "}
                      {this.state.passwordVerification.uppercase ? check : incorrect}
                    </li>
                    <li>
                      {t('onboarding.signup.pass_requirements.lowercase')} {" "}
                      {this.state.passwordVerification.lowercase ? check : incorrect}
                    </li>
                    <li>
                      {t('onboarding.signup.pass_requirements.number')} {" "}
                      {this.state.passwordVerification.digits ? check : incorrect}
                    </li>
                    <li>
                      {t('onboarding.signup.pass_requirements.special')} {" "}
                      {this.state.passwordVerification.specialChar ? check : incorrect}
                    </li>
                  </ul>
                </div>
                <div className="form-group">
                  <Input
                    className="form-control"
                    onChange={this.props.handlePasswordConfirm}
                    placeholder={t('onboarding.signup.password_confirm')}
                    name="passwordConfirm"
                    onValidate={this.handleValidate}
                    required
                    type="password"
                    value={this.props.passwordConfirm} />
                </div>
                <div className={this.props.error ? "" : "hidden"}>
                  <div className="alert alert-warning">
                    <i className="glyphicon glyphicon-remove pull-right" onClick={this.props.handleClearError} />
                    {this.props.error}
                  </div>
                </div>
                <div className={this.state.error ? "" : "hidden"}>
                  <div className="alert alert-warning">
                    <i className="glyphicon glyphicon-remove pull-right" onClick={this.handleClearError} />
                    {this.state.error}
                  </div>
                </div>
                <div className="form-group">
                  <button
                    className="btn btn-block btn-primary"
                    type="submit"
                    disabled={this.props.isLoading || !isFormValid}
                    >
                    {t('onboarding.signup.btn_signup')}
                  </button>
                </div>
                {/* <div className="form-group">                      
                  <div id="gSignInWrapper">
                    <div id="customBtn" className="customGPlusSignIn">
                      <span className="icon"></span>
                      <span className="buttonText">{t('onboarding.signup.google')}</span>
                    </div>
                  </div>
              </div>
              <div className="form-group"> 
               <div>
                <div id="facebookSpinner" className="facebookSpinner">
                        <span>Loading</span>
                        <a href="" className="fb connect" onClick={this.props.clickCreactCuenta}>{t('onboarding.signup.facebook')}</a>
                </div> 
                </div>
              </div> */}
              </fieldset>
            </form>
            <div>
              <p className="small signup">{t('onboarding.signup.login')}
                <button
                  className="btn-link btn_password"
                  onClick={this.props.handleLoginClick}
                  type="button">
                  {t('onboarding.signup.btn_login')}
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>
      
    );
  }
}

export default translate('common')(Signup);



// WEBPACK FOOTER //
// ./src/onboarding/Signup.js